import { Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useModals } from "../../../../context/ModalContext";
import { quoteCreateActions } from "../../../../redux/features/quotes/quote-create-advanced";
import { getSectorWorkflowStepOrder } from "../../../../redux/features/quotes/quote-create-advanced/reducers/sectorWorkflowReducers";
import { selectStep } from "../../../../redux/features/quotes/quote-create-advanced/selectors/navigationSelectors";
import { selectQuoteCreatePayload } from "../../../../redux/features/quotes/quote-create-advanced/selectors/quoteCreateSelectors";
import { selectSectorWorkflow } from "../../../../redux/features/quotes/quote-create-advanced/selectors/sectorWorkflowSelectors";
import { SASButtonStyles } from "../../../ui/styles/inputStyles";
import { buildValidations } from "./validators";
import { addAdvancedQuoteList, updateAdvancedQuoteList } from "../../../../redux/features/quotes/quoteListSlice";

const quoteStepsOrder = ["sector", "summary"];

const { resetSectorWorkflow, nextSectorStep, setStep, previousSectorStep, resetStep, clearAdvancedListEditContext } = quoteCreateActions;

export const QuoteCreateNextPrev = () => {
  const [sendingQuote, setSendingQuote] = useState(false);

  const { closeByKey } = useModals();
  const dispatch = useDispatch();

  const stepQuote = useSelector(selectStep);
  const sectorWorkflow = useSelector(selectSectorWorkflow);
  const finalPayload = useSelector(selectQuoteCreatePayload);
  const alias = useSelector((state) => state.quoteCreate.alias || "");
  const isEditingAdvancedListItem = useSelector((state) => state.quoteCreate.isEditingAdvancedListItem);
  const currStepIndex = quoteStepsOrder.findIndex((s) => s === stepQuote);
  const isLastStep = currStepIndex === quoteStepsOrder.length - 1;

  const sectorStepsOrder = getSectorWorkflowStepOrder(sectorWorkflow);
  const currSectorIndex = sectorStepsOrder.findIndex((s) => s === sectorWorkflow.step);
  const isLastSectorStep = currSectorIndex === sectorStepsOrder.length - 1;

  const validations = buildValidations(finalPayload);
  const canProceed = validations[stepQuote];

  const handleNext = async () => {
    if (!canProceed) return;

    if (stepQuote === "sector") {
      if (!isLastSectorStep) {
        dispatch(nextSectorStep());
        return;
      }
      dispatch(setStep("summary"));
      return;
    }

    if (!isLastStep) {
      dispatch(setStep(quoteStepsOrder[currStepIndex + 1]));
      return;
    }

    // ------------------------------
    //        CREATE VS EDIT
    // ------------------------------

    // Only update when the user actually opened a row via Edit; root `id` can remain stale and would overwrite the wrong list item.
    const advancedAlias = finalPayload.alias || "";

    const finalAdvancedPayload = {
      ...finalPayload,
      alias,
      sectorWorkflow: {
        ...finalPayload.sectorWorkflow,
        alias,
      },
    };

    console.log("ADVANCED PAYLOAD BEFORE SAVE:", finalAdvancedPayload);

    if (isEditingAdvancedListItem && finalAdvancedPayload.id) {
      dispatch(
        updateAdvancedQuoteList({
          id: finalAdvancedPayload.id,
          updates: finalAdvancedPayload,
        }),
      );
    } else {
      dispatch(addAdvancedQuoteList(finalAdvancedPayload));
    }

    dispatch(resetSectorWorkflow());
    dispatch(resetStep());
    dispatch(clearAdvancedListEditContext());
    closeByKey("modal-adv-add");
    closeByKey("Edit-Modal-Quote-Advanced");
    setSendingQuote(true);
  };

  const handlePrevious = () => {
    if (stepQuote === "sector") {
      if (currSectorIndex > 0) {
        dispatch(previousSectorStep());
        return;
      }

      dispatch(resetSectorWorkflow());
      dispatch(setStep("client"));
      return;
    }

    if (currStepIndex > 0) {
      dispatch(setStep(quoteStepsOrder[currStepIndex - 1]));
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "50%",
        gap: "10px",
        mt: 2,
      }}
    >
      <Button
        onClick={handlePrevious}
        variant="contained"
        sx={SASButtonStyles}
        disabled={(stepQuote === "sector" && currSectorIndex === 0) || sendingQuote}
      >
        Previous
      </Button>

      <Button onClick={handleNext} variant="contained" sx={SASButtonStyles} disabled={!canProceed || sendingQuote}>
        {sendingQuote ? "Sending..." : isLastStep && isLastSectorStep ? (finalPayload.id ? "Update" : "Finish") : "Next"}
      </Button>
    </Box>
  );
};
